export type PatientApplyProfileData = PatientApplyProfileDatum[]

type PatientApplyProfileDatum = {
  conceptId?: number
  conceptName?: string
  conceptValue: string
  eligibilityCriteriaId?: number
}

export const NOT_APPLICABLE = 'N/A'
export const SKIPPED_ANSWER = 'skipped'
export const NONE_ANSWER = 'None'
export const NOT_SURE_ANSWER = 'Not Sure'

export const isNotEmptyOrSkippedAnswer = (answer: string) =>
  ![NOT_APPLICABLE, SKIPPED_ANSWER].includes(answer)

export const isNotEmptyOrSkippedOrNoneOrNotSureAnswer = (answer: string) =>
  ![NOT_APPLICABLE, SKIPPED_ANSWER, NONE_ANSWER, NOT_SURE_ANSWER].includes(
    answer,
  )
